import React from 'react';
import HpsTable from './HpsTable';

const HydrocarbonCondensatTable = ({ refreshTrigger }) => (
  <HpsTable procurementTypeHeader='2' refreshTrigger={refreshTrigger} />
);

export default React.memo(HydrocarbonCondensatTable);
